// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/vi'
import * as filters from './filters'
import * as mixins from './mixins'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import 'semantic-ui-button/button.min.css'
import 'semantic-ui-label/label.min.css'
// global components
import GsTable from 'src/components/app/gsTable/GsTable'
import gsTableHelper from 'src/components/app/gsTable/mixins'
import GsHeader from 'src/components/app/GsHeader'
import VueClipboard from 'vue-clipboard2'
// configs axios
import 'src/api/config'

sync(store, router)
// element-ui
Vue.use(ElementUI, {locale})
Vue.use(VueClipboard)

// global components
Vue.component('gs-table', GsTable)
Vue.mixin(gsTableHelper)
Vue.component('gs-header', GsHeader)

// custom filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
// common mixins
Object.keys(mixins).forEach(key => {
  Vue.mixin(mixins[key])
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})




// WEBPACK FOOTER //
// ./src/main.js